const Circle = ({ cx, cy, r }: { cx: number; cy: number; r: number }) => {
  return <circle cx={cx} cy={cy} r={r} />;
};

export default Circle;
